// extracted by mini-css-extract-plugin
export default {"inProgress":"_1IN-R"};